import { isAnnuityPolicy, isOldAlicUlPolicy } from "js/utilities";
import moment from "moment";

export const getBadgeClassByPolicyStatus = (selectedPolicy) => {
  const status = selectedPolicy?.status?.toLowerCase() || "";
  const costOfInsuranceDueDate =
    selectedPolicy?.costOfInsurance?.costOfInsuranceDueDate;
  const isULPolicy = isOldAlicUlPolicy(selectedPolicy);
  const dueDate = isULPolicy
    ? moment(selectedPolicy?.costOfInsurance?.costOfInsuranceDueDate)
    : moment(selectedPolicy?.premiumDueDate);
  const isDueDateBeforeNow = dueDate.isBefore(moment(), "day");

  switch (status) {
    case "paid-up":
    case "reducedpaidup":
    case "extended term":
      return "good";
    case "":
    case "reinstated":
    case "active":
      if (isULPolicy && !costOfInsuranceDueDate) {
        return selectedPolicy?.graceFlag?.toLowerCase() === "y"
          ? "risk"
          : "good";
      }
      if (isAnnuityPolicy(selectedPolicy)) {
        return "good";
      }
      return isDueDateBeforeNow ? "risk" : "good";
    default:
      return "problem";
  }
};
